   
    $(window).scroll(function() {
      if ($(this).scrollTop() >= 200) {        
        $(".filter-main").addClass("sticky");   
      } else {
        $(".filter-main").removeClass("sticky");
      }
    });	
  